<template>
	<div>
		<Header :event="event" v-on:date-select="onDateSelect"></Header>
		<div class="event-body">
			<div class="sub-head">
				<span class="date-chosen">
					{{ getDateRange(dateRange[0], dateRange[1])}}
				</span>
				<span class="dot"></span>
				<span class="patient-count">
					{{ getEventCards.all || 0 }} patients
				</span>
			</div>
			<ProgressBar color-type="engagement" v-if="isLoading"></ProgressBar>
			<div v-else-if="isPatientScheduled">
				<EventActionCards
					:event="event"
					:date-range="dateRange"
					:data="getEventCards">
				</EventActionCards>
				<EventActionTable
					:event="event"
					:data="getEventActions"></EventActionTable>
			</div>
			<div class="event-error" v-else>
				No patient is scheduled for {{event.name}} {{ dateRange[1]?'between':'for' }} {{ getDateRange(dateRange[0], dateRange[1])}}
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import formatDelay from '@/module/util/format-delay'

import Header from './Header'
import EventMixin from './mixin'

import EventActionCards from '../common/ActionCards'
import EventActionTable from '../common/ActionTable'

import ProgressBar from '@/module/component/ProgressBar'

export default {
	name: 'event',
	mixins: [ EventMixin ],
	props: {
		event: {
			type: Object,
			default: () => ({})
		}
	},
	mounted() {
		const anchor = this.$router.currentRoute.hash
		this.$nextTick(() => {
			if (anchor && document.querySelector(anchor)) setTimeout(() => { location.href = anchor }, 1000)
		})
	},
	data() {
		return {
			dateRange: [null, null]
		}
	},
	methods: {
		...mapActions('engagement',['loadEventData']),
		onDateSelect(dateRange) {
			this.dateRange = dateRange
			this.getEventData()
		},
		uniqueLength (userArr) { 
			return [...new Set(userArr.map(({user}) => user))].length
		},
		getEventData() {
			this.loadEventData({
				event: this.event.id,
				start: this.dateRange[0].setHours(0,0,0,0),
				end: this.dateRange[1] ? this.dateRange[1].setHours(0,0,0,0) : null
			})
		}
	},
	computed: {
		...mapState('engagement',{
			isLoading (state) {
				return state.loading[this.event.id]
			}
		}),
		isPatientScheduled() {
			const eventData = this.$store.state.engagement.event
			return eventData && eventData[this.event.id] && eventData[this.event.id].patients.length > 0
		},
		getEventCards() {
			return this.$store.getters['engagement/getEventCards'](this.event)
		},
		getEventActions() {
			//console.log(this.$store.state.engagement.event)
			if(this.$store.state.engagement.event) {
				try{
					const eventAction = this.$store.state.engagement.event[this.event.id]
					return eventAction[this.event.id].map(message => {
						// Calculating total delay to show
						let delayDay = Math.floor(message.delay / 86400000)
						const delayTitle = formatDelay(message.delay)
						//Calculating total opened count
						const openedCount = message.opened ? this.uniqueLength(message.opened) : 0
						//Calculating Got it count
						const acceptCount = message.accepted ? this.uniqueLength(message.accepted) : 0
						//Calculate Action count
						const actionCount = message.action ? this.uniqueLength(message.action) : 0
						//Calculate no Action count
						const noActionCount = eventAction.patients.filter(patient => {
							if(message.opened) {
								if(message.opened.find(({user}) => patient.id === user) !== undefined) return false
							}
							if(message.accepted) {
								if(message.accepted.find(({user}) => patient.id === user) !== undefined) return false
							}
							if(message.action) {
								if(message.action.find(({user}) => patient.id === user) !== undefined) return false
							}
							return true
						}).length
						const {id, title} = message
						return {
							id,
							title,
							delayDay,
							delayTitle,
							openedCount,
							acceptCount,
							noActionCount,
							actionCount
						}
					})
				}
				catch(e) {
					return []
				}
				
			}
			return []
		}
	},
	components: {
		Header,
		EventActionCards,
		EventActionTable,
		ProgressBar
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
.event-body {
	padding: 20px 12px;
	padding-bottom: 50px;
	border-bottom: solid 2px #2d3e4f;
	position: relative;
}
.sub-head {
	font-size: 22px;
	font-weight: 500;
}
.event-error {
	padding-top: 30px;
	color: #da4e4e
}
</style>
